<style lang="scss" scoped>
    #header {
        padding-top: 60px;
        background: url("../../../../images/index-bg-repeat.png") repeat-x;
        background-size: 20px 450px;
        /*position: absolute;*/
        width: 100%;
        height: 470px;
        left: 0;

        div {
            text-align: center
        }
    }

    .my-avatar {
        border-radius: 500rem;
        border: 2px solid #e8e8e8;
        height: 100px;
        width: 100px;
    }

    .intro {
        font-size: 16px;
        margin-top: 10px;
    }

    .nick {
        margin-top: 5px;
        font-size: 24px;
        font-style: italic;
    }

    .follow_me {
        margin-top: 20px;
        align-content: center;
    }
</style>

<template>
    <div id="header" :style="{marginTop: marginTop + 'px'}">
        <div>
            <img class="my-avatar" :class="{animated: animated, fadeIn: fadeIn}" :src="avatar" v-on:error="guarantee">
        </div>
        <div class="nick">{{nickname}}</div>
        <div class="intro">
            <p>👨‍💻‍ 服务端研发工程师 🎉</p>
            <p>🔧 PHP & Golang & Java ✨</p>
        </div>
        <div class="follow_me">
            <a class="ui basic green button mini" target="_blank"
               href="http://weibo.com/gm106668888">关注我</a>
        </div>
    </div>
</template>

<script>
    import 'semantic-ui-button/button.min.css';

    export default {
        data() {
            return {
                animated: true,
                fadeIn: true,
                nickname: '',
                avatar: '',
                default_avatar: '',
            }
        },
        props: {
            marginTop: {
                type: Number,
                default: 0,
                validator: function (value) {
                    return value >= 0
                }
            },
        },
        mounted() {
            axios.get('/me').then((res) => {
                this.nickname = res.data.nickname;
                this.avatar = "https://avatars.githubusercontent.com/u/11913291"; // 使用Github头像
                this.default_avatar = res.data.avatar;
            });
        },
        methods: {
            guarantee() {
                this.avatar = this.default_avatar
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/web/components/index/header.vue